import { memo } from "react";
import { useQuery } from "@tanstack/react-query";
import { dashboardService } from "@/services/DashboardService";
import { DistributionCard } from "./DistributionCard";
import { PieCard } from "./PieCard";
import { COLORS_GEO } from "./constants";
import { moneyFormatter } from "@/config/currency";
import type { DistributionItem } from "@/lib/utils";

// Currency from one place (src/config/currency.ts); whole euros here.
const currencyFmt = moneyFormatter({ maximumFractionDigits: 0 });

interface DashboardDistributionsProps {
  data: {
    siteTypes: DistributionItem[];
    geo: DistributionItem[];
    keywords: DistributionItem[];
    languages: DistributionItem[];
  };
}

export const DashboardDistributions = memo(
  ({ data }: DashboardDistributionsProps) => {
    // Revenue replaced the Language card (owner's call, 30.09.2026).
    const { data: revenue = [], isLoading: revenueLoading } = useQuery({
      queryKey: ["dashboard", "revenue-by-brand"],
      queryFn: () => dashboardService.getRevenueByBrand(),
      staleTime: 1000 * 60 * 5,
    });
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        <DistributionCard
          title="BY SITE TYPES"
          items={data.siteTypes}
          type="progress"
          reportLink="/reports?tab=site-types"
        />
        <DistributionCard
          title="BY GEO"
          items={data.geo}
          type="progress"
          reportLink="/reports?tab=geo"
          colors={COLORS_GEO}
        />
        <DistributionCard
          title="BY KEYWORD (BRAND)"
          items={data.keywords}
          type="list"
          reportLink="/reports?tab=keywords"
        />
        <PieCard
          title="REVENUE BY BRAND · 30 DAYS"
          items={revenue}
          reportLink="/clicks?groupBy=brand"
          formatValue={(v) => currencyFmt.format(v)}
          loading={revenueLoading}
        />
      </div>
    );
  },
);

DashboardDistributions.displayName = "DashboardDistributions";
